import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

const Footer = () => (
  <footer className="site-footer">
    <div className="site-footer__content">
      <span>
      © Trivia Weekend — an unofficial trivia companion
      </span>

      <div className="site-footer__links">
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms</Link>
      </div>
    </div>
  </footer>
)

export default Footer